import { type FileInfo, type FileKind, FileStatus } from '../../models/File'
import { useUploadFileMutation, useUploadFileRequestMutation } from '../../store/media/file'
import { useUpdateFileMutation } from '../../store/media/media'
import { type UploadProgressCallback } from './models'

export const useAssetFileUpload = (accountId: string, kind: FileKind) => {
  const [uploadFileRequest] = useUploadFileRequestMutation()
  const [uploadFile] = useUploadFileMutation()
  const [updateFile] = useUpdateFileMutation()

  return async (file: File, onProgress: UploadProgressCallback): Promise<FileInfo> => {
    const { data } = await uploadFileRequest({
      accountId,
      body: { fileName: file.name, fileSize: file.size, contentType: file.type, kind },
    }).unwrap()
    onProgress(50)
    await uploadFile({ uploadUrl: data.fileUploadUrl, uploadParameters: data.fileUploadParameters, file }).unwrap()
    await updateFile({ accountId, fileId: data.fileInfo.fileId, body: { status: FileStatus.UPLOADED } }).unwrap()
    onProgress(90)
    return { fileId: data.fileInfo.fileId, fileName: file.name, fileSize: file.size }
  }
}
